import React, { Component } from 'react';
import ReferralLinkPanel from '../../../../../../components/UserReferral/ReferralLinkPanel';

// eslint-disable-next-line react/prefer-stateless-function
class ReferralLinkBlock extends Component {
  render() {
    return <ReferralLinkPanel {...this.props} />;
  }
}

export default ReferralLinkBlock;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/ReferralProgram/ReferralMyStat/ReferralLinkBlock/ReferralLinkBlock.js